export abstract class BaseDto<T> {
    public static getId(object: any): string {
        if (object.id) {
            return object.id;
        }

        return object;
    }

    protected clone(): any {
        return JSON.parse(JSON.stringify(this));
    }

    protected getId(object: any): string {
        return BaseDto.getId(object);
    }

    public abstract toBody(): any;

    public abstract toModel(): T;
}
